<template>
  <div class="root">
    <div class="root-wrapper">
      <div class="btn" @click="switchIndex(swiperIndex - 1)">
        <template v-if="swiperIndex > 0">
          <img src="//img.souche.com/f2e/6377c81bcf8f6ee35fb0b930b9cdf061.svg" class="btn-item" />
          <img src="//img.souche.com/f2e/4a8a79c2f700be566594f44bc63c7db8.svg" class="btn-hover btn-item" />
        </template>
        <img src="//img.souche.com/f2e/fb19fed91b8941ac5cd1926817979564.svg" class="btn-left" v-else />
      </div>
      <div class="swiper" ref="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <component
            :is="Item"
            class="swiper-slide"
            v-for="item in displayData"
            :key="item.txt"
            :img="item.img"
            :date="item.date"
            :txt="item.txt"
          />
        </div>
      </div>
      <div class="btn btn-right" @click="switchIndex(swiperIndex + 1)">
        <template v-if="swiperIndex < displayData.length - 1">
          <img src="//img.souche.com/f2e/6377c81bcf8f6ee35fb0b930b9cdf061.svg" class="btn-item" />
          <img src="//img.souche.com/f2e/4a8a79c2f700be566594f44bc63c7db8.svg" class="btn-hover btn-item" />
        </template>
        <img src="//img.souche.com/f2e/fb19fed91b8941ac5cd1926817979564.svg" class="btn-left" v-else />
      </div>
    </div>
    <div class="indicator">
      <div class="line"></div>
      <div
        v-for="item in displayTimeLines"
        :key="item"
        class="item"
        @click="onTimeLineClick(item)"
        ref="timeLineItems"
        :class="displayTimeLines[timeLineIndex] === item ? 'item-active' : ''"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import HistoryItem from "./HistoryItem.vue";
import HistoryItemMob from "./HistoryItemMob.vue";
export default {
  components: { HistoryItem, HistoryItemMob },
  i18n: {
    messages: {
      zh: {
        2012.12: "大搜车成立",
        2013.6: "推出二手车商数字化运营系统\n“大风车”",
        "2017.10": "收购新车货源信息及渠道服务平台“车行168”",
        2018.4: "收购二手车B2B交易平台\n“车易拍”",
        2018.8: "收购汽车智能供应链仓储物流综合服务商“运车管家”",
        2019.3: "与淘宝二手车达成战略合作",
        2019.6: "推出新零售场景数字化解决方案“大搜车超级4S”",
        2020.5: "与吉利汽车达成战略合作，\n共建国内首个数字化汽车\n直销新零售网络",
        2020.6: "与奇瑞汽车达成战略合作，共同\n推进汽车直销",
        "2020.6-2": "收购汽车厂商营销数字化服务平台“云漾科技”",
        2021.6: "推出二手车检测认证服务“268V”",
        2021.7: "推出车辆到家交付业务",
        2021.12: "与山东国惠投资控股集团共同出资10亿元，成立国泰大搜车汽车\n融资租赁公司",
        2022.7: "推出二手车金融导流服务",
        2023.2: "与平安银行达成战略合作，共同\n发力汽车金融数字化",

        mob: {
          2012.12: "大搜车成立",
          2013.6: "推出二手车商数字化运营系统“大风车”",
          "2017.10": "收购新车货源信息及渠道服务平台\n“车行168”",
          2018.4: "收购二手车B2B交易平台“车易拍”",
          2018.8: "收购汽车智能供应链仓储物流综合服务商\n“运车管家”",
          2019.3: "与淘宝二手车达成战略合作",
          2019.6: "推出新零售场景数字化解决方案“大搜车超级4S”",
          2020.5: "与吉利汽车达成战略合作，共建国内首个\n数字化汽车直销新零售网络",
          2020.6: "与奇瑞汽车达成战略合作，共同推进汽车直销",
          "2020.6-2": "收购汽车厂商营销数字化服务平台\n“云漾科技”",
          2021.6: "推出二手车检测认证服务“268V”",
          2021.7: "推出车辆到家交付业务",
          2021.12: "与山东国惠投资控股集团共同出资10亿元，成立国泰大搜车汽车融资租赁公司",
          2022.7: "推出二手车金融导流服务",
          2023.2: "与平安银行达成战略合作，共同发力汽车\n金融数字化",
        },
      },
      en: {
        title: "ABOUT US",
        2012.12: "DaSouChe founded",
        2013.6: 'Launched "DaFengChe," a digital operating system for used car dealers',
        "2017.10": 'Acquired "CheHang 168," a new car information platform and digital operating system for new car brokers',
        2018.4: 'Acquired "CheYiPai," a used car B2B auction platform',
        2018.8:
          'Acquired "YunCheGuanJia," a vehicle delivery service provider focusing on smart warehousing and vehicle shipping platforms',
        2019.3: "Entered into strategic alliance with Taobao in the used car space",
        2019.6: 'Launched "DaSouChe Super 4S," a digital solutions products for authorized dealers\' used car business',
        2020.5: "Entered into strategic collaboration with Geely to build a pioneering direct-to-consumer digital retail network",
        2020.6: "Entered into strategic collaboration with Chery to jointly promote direct-to-consumer car sales",
        "2020.6-2": 'Acquired "YunYang Technology," a digital marketing service platform for OEMs',
        2021.6: 'Launched "268V," a used car inspection and certification service',
        2021.7: "Launched home delivery services for new cars",
        2021.12:
          "Established Guotai-DaSouChe Auto Financing and Leasing Company, a joint-venture  with RMB 1.0 billion in registered capital, with Shandong Guohui Investment Holding Group",
        2022.7: "Launched used car financing referral service",
        2023.2:
          "Entered into strategic collaboration with PingAn Bank to jointly promote digitalization of used car financing for consumers",
      },
    },
  },
  data() {
    return {
      timeLineIndex: 0,
      swiperIndex: 0,
      historys: [
        {
          date: "2012",
          items: [
            {
              date: "2012.12",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2012.12"] : this.$t("2012.12"),
              img: "//img.souche.com/f2e/f35b3af1664ca266e4f5e4a4f586524d.jpg",
            },
          ],
        },
        {
          date: "2013",
          items: [
            {
              date: "2013.6",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2013.6"] : this.$t("2013.6"),
              img: "//img.souche.com/f2e/e5ab843084279ff03340db07bfdec410.png",
            },
          ],
        },
        {
          date: "2017",
          items: [
            {
              date: "2017.10",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2017.10"] : this.$t("2017.10"),
              img: "//img.souche.com/f2e/6b1a99b504495291500c2ac81b32f0b7.png",
            },
          ],
        },
        {
          date: "2018",
          items: [
            {
              date: "2018.4",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2018.4"] : this.$t("2018.4"),
              img: "//img.souche.com/f2e/3414805b2339a3f210eae70733c39098.jpg",
            },
            {
              date: "2018.8",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2018.8"] : this.$t("2018.8"),
              img: "//img.souche.com/f2e/ff64f8f74eed254e3100aa08b75dc5d9.jpg",
            },
          ],
        },
        {
          date: "2019",
          items: [
            {
              date: "2019.3",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2019.3"] : this.$t("2019.3"),
              img: "//img.souche.com/f2e/e00d05782c8cef6b58dd995e03b3af62.jpg",
            },
            // {
            //   date: "2019.6",
            //   txt: this.$t("2019.6"),
            //   img: "//img.souche.com/f2e/a5aa28a3d77f994cc3d8a79c4b9b585e.png",
            // },
          ],
        },
        {
          date: "2020",
          items: [
            {
              date: "2020.5",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2020.5"] : this.$t("2020.5"),
              img: "//img.souche.com/f2e/0b7f9a935c0612db58d12ed5632a360e.png",
            },
            {
              date: "2020.6",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2020.6"] : this.$t("2020.6"),
              img: "//img.souche.com/f2e/5916a0f2441cf76652d8717764c04fc5.png",
            },
            {
              date: "2020.6",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2020.6-2"] : this.$t("2020.6-2"),
              img: "//img.souche.com/f2e/8abaebd52516f4c07c37ada989f9be75.png",
            },
          ],
        },
        {
          date: "2021",
          items: [
            {
              date: "2021.6",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2021.6"] : this.$t("2021.6"),
              img: "//img.souche.com/f2e/23db95ea21b63ecca0099f6ec31b769d.jpg",
            },
            {
              date: "2021.7",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2021.7"] : this.$t("2021.7"),
              img: "//souche.oss-cn-hangzhou.aliyuncs.com/20230531/jpg/44c9bfb46cc57d3823b59bcf03ee3949.jpg",
            },
            {
              date: "2021.12",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2021.12"] : this.$t("2021.12"),
              img: "//img.souche.com/f2e/c5961026691ac12dce72e47f72d626f7.jpeg",
            },
          ],
        },
        {
          date: "2022",
          items: [
            {
              date: "2022.7",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2022.7"] : this.$t("2022.7"),
              img: "//souche.oss-cn-hangzhou.aliyuncs.com/20230531/jpg/bdd92809809f215716b710619ea38e7e.jpg",
            },
          ],
        },
        {
          date: "2023",
          items: [
            {
              date: "2023.2",
              txt: this.$isMob() && this.$isCN() ? this.$t("mob")["2023.2"] : this.$t("2023.2"),
              img: "//img.souche.com/f2e/e3b35f747b941b3f730d653b9bfeb0b4.JPG",
            },
          ],
        },
      ],
    };
  },
  computed: {
    Item() {
      return this.$isMob() ? HistoryItemMob : HistoryItem;
    },
    displayData() {
      const vals = [];
      this.historys.forEach((h) => {
        vals.push(
          ...h.items.map((i) => {
            return { ...i, year: h.date };
          })
        );
      });
      return vals;
    },
    displayTimeLines() {
      return this.historys.map((h) => {
        return h.date;
      });
    },
  },
  mounted() {
    this.$store.watch(
      (state) => state.isMobileSite,
      () => {
        console.log("changed");
        this.mountSwiper();
      }
    );
    this.mountSwiper();
  },
  watch: {
    timeLineIndex() {
      if (!this.$isMob()) {
        return;
      }
      const currentEl = this.$refs.timeLineItems[this.timeLineIndex];
      const rect = currentEl.getBoundingClientRect();
      const targetPos = window.innerWidth / 2 - rect.width / 2;
      if (rect.left < 0) {
        currentEl.parentElement.scrollBy({ left: rect.left - targetPos, behavior: "smooth" });
      } else if (rect.right > window.innerWidth) {
        currentEl.parentElement.scrollBy({ left: rect.left - targetPos, behavior: "smooth" });
      }
    },
  },
  methods: {
    mountSwiper() {
      import("./swiper/swiper").then((Swiper) => {
        Swiper = Swiper.default || Swiper;
        try {
          this.swiper && this.swiper.destroy();
        } catch (e) {
          console.log(e);
        }
        const _this = this;
        this.swiper = new Swiper(this.$refs.swiper, {
          grabCursor: true,
          effect: this.$isMob() ? "slide" : "creative",
          slidesPerView: this.$isMob() ? "auto" : 1,
          spaceBetween: this.$isMob() ? 16 : 0,
          centeredSlides: true,
          creativeEffect: {
            prev: {
              shadow: false,
              translate: ["-120%", 0, -500],
            },
            next: {
              shadow: false,
              translate: ["120%", 0, -500],
            },
          },
          on: {
            slideChange() {
              _this.switchIndex(this.activeIndex);
            },
          },
        });
      });
    },
    switchIndex(index) {
      if (index < 0 || index >= this.displayData.length) {
        return;
      }
      const item = this.displayData[index];
      const year = item.year;
      const newIndex = this.displayTimeLines.findIndex((t) => t === year);
      this.timeLineIndex =
        newIndex < 0 ? this.timeLineIndex : newIndex >= this.displayTimeLines.length ? this.displayTimeLines.length - 1 : newIndex;
      this.swiper.slideTo(index);
      this.swiperIndex = index;
    },
    onTimeLineClick(year) {
      if (this.displayTimeLines[this.timeLineIndex] === year) {
        return;
      }
      const swipperIndex = this.displayData.findIndex((data) => data.year === year);
      this.switchIndex(swipperIndex);
    },
  },
  beforeDestroy() {
    this.swiper && this.swiper.destroy();
  },
};
</script>

<style lang="less" scoped>
@import "../imported.less";
.root {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
}

.root-wrapper {
  display: flex;
  overflow: hidden;
  align-items: center;

  .btn {
    width: 64px;
    height: 64px;
    position: relative;
    cursor: pointer;
  }

  .btn-right {
    transform: rotateZ(180deg);
  }

  .btn-item {
    bottom: 0;
    right: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .btn-hover {
    opacity: 0;
  }
}

.indicator {
  width: var(--min-content-width);
  padding-top: 72px;
  padding-bottom: 76px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: scroll;
  margin: 0 auto;
  justify-content: space-around;

  &::-webkit-scrollbar {
    display: none;
  }

  .line {
    .border-1px(rgba(228, 228, 228, 1));
    position: absolute;
    top: 99px;
    left: 0;
    right: 0;
    z-index: -1;
  }

  .item {
    width: 54px;
    height: 54px;
    background: linear-gradient(180deg, #fcfbfa 0%, #ffffff 100%);
    box-shadow: 1px 5px 12px #f3ebe8;
    border-radius: 50%;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 52px;
    text-align: center;
    color: #b4b5b7;
    transition: all ease 0.3s;
    flex-shrink: 0;
    cursor: pointer;

    &:focus-visible {
      outline: none;
    }

    &-active {
      transform: scale(1.4);
      color: #ff571a;
    }
  }
}

.swiper-slide {
  height: auto;
}

.swiper-wrapper {
  // display: flex;
  // align-items: stretch;
}

@media screen and (min-width: 540px) {
  .indicator {
    .item {
      &:hover {
        transform: scale(1.4);
        color: #ff571a;
      }
    }
  }

  .btn-hover {
    &:hover {
      opacity: 1;
      transition: opacity ease 0.3s;
    }
  }
}

.swiper {
  width: 1067px;
  margin: 0 70px;
}

@media screen and (max-width: 540px) {
  .bg,
  .btn {
    display: none;
  }

  .swipper-wrapper,
  .swiper {
    width: 100%;
    margin: 0;
  }

  .indicator {
    width: calc(100vw - 30px);
    height: 103px;
    box-sizing: border-box;
    position: static;
    display: flex;
    flex-direction: row;
    overflow: scroll hidden;
    padding-top: 20px;
    padding-bottom: 0;
    margin-left: 15px;
    justify-content: unset;
    &::-webkit-scrollbar {
      display: none;
    }

    .line {
      bottom: 60px;
      left: 15px;
      right: 15px;
      // height: px;
      top: unset;
    }

    .item {
      flex-shrink: 0;
      width: 47px;
      height: 47px;
      box-shadow: 1px 2px 6px #f3ebe8;
      border-radius: 50%;
      font-size: 10px;
      line-height: 47px;
      cursor: unset;

      &:not(:first-child) {
        margin-left: 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/History.vue